module.exports = __webpack_public_path__ + "static/q3answer4_terrace_wishmas-3a0748517a4a773c2defdf92a6eb1781.jpg";